<template>
  <b-form @submit.prevent="handleSubmit()">
    <div class="lead">{{$t('passwordRecovery.title')}}</div>
    <div class="form-group mt-3">
      <label for="_email" class="control-label">{{ $t("user.field.email") }}</label>
      <b-form-input v-model="email" type="text" required id="_email" :placeholder="$t('passwordRecovery.placeholder')" />
    </div>
    <button type="submit" class="btn btn-primary">{{ $t("global.form.submit") }}</button>
  </b-form>
</template>

<script>
  import {validateEmail} from "../../helper";
  import {mapGetters} from "vuex";

  export default {
    data: () => {
      return {
        email: null
      }
    },
    computed: mapGetters({
      passwordRecoveryError: "user/passwordRecovery/error"
    }),
    methods: {
      handleSubmit() {
        if (!this.validateEmail(this.email)) {
          this.$notify.error(this.$t('passwordRecovery.error.wrongEmail'));
          return null;
        }
        const uri = location.origin + '/' + this.$router.resolve({name:"PasswordRecoveryWithToken", params:{token:"__token__"}}).href;
        this.$store.dispatch("user/passwordRecovery/submit", {email: this.email, uri: uri}).then(() => {
          this.$notify.success(this.$t('passwordRecovery.successSendEmail'));
        });
      },
      validateEmail,
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/PasswordRecovery.vue